import { useEffect } from 'react';

import Layout from "../../hocs/layout/Layout";
import NavBar from "../../components/navigation/Navbar";
import Footer from "../../components/navigation/Footer";
// import ContactForm from "components/contact/ContactForm";
// import Header from "components/contact/Header";
// import Mapa from "components/contact/Mapa";
import Thanks from "../../components/contact/Thanks";
import Noticias from '../../components/home/Noticias';



function Contacto(){
    useEffect(() => {
            window.scrollTo(0,0)
        },[])
    return(
        <Layout>
            <NavBar/>
            <div>
                <Thanks/>
                <Noticias/>
            </div>
            <Footer/>
        </Layout>
    )
}export default Contacto;